export enum Alignment {
    Start = 'start',
    Center = 'center',
    End = 'end',
}

export enum VirtualDirection {
    Horizontal = 'horizontal',
    Vertical = 'vertical',
}

export interface VirtualDirectionProps {
    direction: VirtualDirection;
}

export interface VirtualSizerElementProps extends VirtualDirectionProps {
    scrollableSize: number;
}

export interface VirtualProps {
    defaultItemWidth: number;
    defaultItemHeight: number;
    containerPaddingVertical: number;
    overscanSize?: number;
    currentIndex?: number;
    scrollToAlignment?: Alignment;
    direction: VirtualDirection;
    children?: React.ReactNode;
    shouldScrollToIndex?: boolean;
    containerSize?: number;
    onScrollableSizeChange?: (size: number) => void;
}

export interface VirtualState {
    offset: number;
    scrollReason?: 'observed' | 'requested';
}

export interface Child {
    key: React.Key;
    child: React.ReactChild;
}

export interface DirectionDependentAttributes {
    dimension: 'height' | 'width';
    scrollDirection: 'scrollTop' | 'scrollLeft';
}

export interface ViewportCalculationOptions {
    startPosition: number;
    endPosition: number;
    defaultItemSize: number;
}
